module.exports = __webpack_public_path__ + "sansg/img/white.f33b3451.png";